import { useTransitionMap } from "react-transition-state";

import { useAppContext } from "../AppContext";
import GridItem from "./GridItem";
import PlaceholderGridItem from "./PlaceholderGridItem";
import { TransitionProvider } from "./TransitionContext";

const { Suspense, use } = window.React;

const GRID_ITEM_CLASSES =
    "col-xl-4 col-lg-4 col-md-6 col-12 mb-4 position-relative";

function AsyncGrid() {
    const { postsPromise, resetFilters } = useAppContext();
    const posts = use(postsPromise);

    if (posts.length === 0) {
        return (
            <button
                type="button"
                className="link-reset font-weight-bold btn btn-link text-primary"
                onClick={resetFilters}
            >
                No posts found. Click here to reset filters.
            </button>
        );
    }

    return posts.map((post) => (
        <GridItem
            key={`post-id-${post.ID}`}
            post={post}
            gridItemClasses={GRID_ITEM_CLASSES}
        />
    ));
}

function GridPlaceholders({ count }) {
    return Array.from({ length: count }).map((_, idx) => (
        <div
            key={`placeholder-${idx}`}
            className={`${GRID_ITEM_CLASSES} resource-hub-grid-item card-appear pre-enter`}
        >
            <PlaceholderGridItem />
        </div>
    ));
}

export default function Grid() {
    const { postsRef } = useAppContext();

    const transitionMap = useTransitionMap({
        mountOnEnter: true,
        unmountOnExit: true,
        allowMultiple: true,
        initialEntered: false,
        timeout: 400,
        preEnter: true,
        preExit: true,
    });

    const placeholderCount = postsRef.current.length <= 1 ? 6 : 3;

    return (
        <TransitionProvider value={transitionMap}>
            <div className="col-lg-12 col-xl-9 col-12 my-4 px-4 px-lg-3">
                <div className="row">
                    <Suspense
                        fallback={
                            <>
                                {postsRef.current.map((post) => (
                                    <GridItem
                                        key={`post-id-${post.ID}`}
                                        post={post}
                                        gridItemClasses={GRID_ITEM_CLASSES}
                                    />
                                ))}
                                <GridPlaceholders count={placeholderCount} />
                            </>
                        }
                    >
                        <AsyncGrid />
                    </Suspense>
                </div>
            </div>
        </TransitionProvider>
    );
}
